import type { ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';

export type CreditAnalysisDocumentReviewStatus = 'pending' | 'approved' | 'rejected';

export interface CreditAnalysisDocumentReview {
  id: string;
  accountId: string;
  creditAnalysisId: string;
  accountUploadId: string;
  status: CreditAnalysisDocumentReviewStatus;
  rejectionReason?: string;
  reviewedBy?: { id: string; name: string };
  reviewedAt?: string;
  createdAt: string;
  updatedAt: string;
}

export const creditAnalysisDocumentReviewApi = {
  create: async (params: {
    creditAnalysisId: string;
    accountUploadId: string;
  }): Promise<CreditAnalysisDocumentReview> => {
    const { data } = await api.post<ApiResponse<CreditAnalysisDocumentReview>>(
      '/commercial/credit-analysis-document-reviews',
      params,
    );
    return data.data;
  },

  updateStatus: async (params: {
    id: string;
    status: CreditAnalysisDocumentReviewStatus;
    rejectionReason?: string;
  }): Promise<CreditAnalysisDocumentReview> => {
    const { id, ...body } = params;
    const { data } = await api.patch<ApiResponse<CreditAnalysisDocumentReview>>(
      `/commercial/credit-analysis-document-reviews/${id}/status`,
      body,
    );
    return data.data;
  },

  list: async (creditAnalysisId: string): Promise<CreditAnalysisDocumentReview[]> => {
    const { data } = await api.get<ApiResponse<CreditAnalysisDocumentReview[]>>(
      '/commercial/credit-analysis-document-reviews',
      { params: { creditAnalysisId } },
    );
    return data.data;
  },

  sync: async (params: {
    creditAnalysisId: string;
    accountId: string;
  }): Promise<CreditAnalysisDocumentReview[]> => {
    const { data } = await api.post<ApiResponse<CreditAnalysisDocumentReview[]>>(
      '/commercial/credit-analysis-document-reviews/sync',
      params,
    );
    return data.data;
  },

  getById: async (id: string): Promise<CreditAnalysisDocumentReview> => {
    const { data } = await api.get<ApiResponse<CreditAnalysisDocumentReview>>(
      `/commercial/credit-analysis-document-reviews/${id}`,
    );
    return data.data;
  },
};
